<template>
	<bsh-modal 
		titulo="Editar Arquivo"
		tamanho="modal-lg"
		:name="name">
		<template v-slot:default>
			<div class="form-row">
		    	<div class="form-group col-md-12">
					<input 
				        type="text" 
				        class="form-control" 
				        v-model="dado">
				</div>
			</div>
			<div class="form-row">
		    	<div class="form-group col-md-12">
	        		<img :src="file.src" width="100%" height="100%">
	        	</div>
	        </div>
	    </template>
	    <template v-slot:footer>
        	<button 
        		type="button" 
        		class="btn btn-primary" 
        		@click="update">
        		Salvar
        	</button>
        </template>
    </bsh-modal>
</template>

<script>
	export default {
		props: ['file'],
		data(){
			return {
				name: 'update_arquivo',
				dado: '',
				extension: ''
			}
		}, 
		methods: {
			update(){
				$('#'+this.name).modal('hide')
				this.$emit('update', this.dado+this.extension);
			},
		},
		watch: {
			file(){
				this.dado = '';
				let split = this.file.nome.split('.')
				for(let i=0; i<split.length - 1; i++) {
					if(i == (split.length - 2)){
						this.dado += String(split[i])
					} else {
						this.dado += String(split[i])+'.'
					}
				}
				this.extension = '.'+split[split.length - 1]
			}
		}
	}
</script>